import { jsx as m } from "react/jsx-runtime";
import { propagateTestid as e } from "./utils/helpers.js";
import { c as n } from "./index-Cu0xwYjD.js";
import { forwardRef as c } from "react";
const a = "ids-combobox--input-v501", b = "ids-combobox-v501", p = "ids-combobox--popover-content-v501", d = "ids-combobox--option-list-v501", r = {
  input: a,
  combobox: b,
  "ids-menuItem": "ids-menu-item-v501",
  popoverContent: p,
  optionList: d
}, x = c(
  ({ dataTestId: t, hiddenInputProps: o, ...s }, i) => /* @__PURE__ */ m(
    "input",
    {
      ...o,
      ...s,
      className: n(o == null ? void 0 : o.className, r.hiddenInput),
      "data-testid": e(t, "hidden-input"),
      ref: i,
      type: "hidden"
    }
  )
);
x.displayName = "ComboboxHiddenInput";
export {
  x as C,
  r as s
};
